import React from "react"
import { ModulesYamlKinds } from "../../types/graphql-types"
import { WorkloadItem } from "./workloads"
import { Course } from "./courses"
import { graphql } from "gatsby"

export const modulesKindsQuery = graphql`
  fragment ModulesKinds on ModulesYamlKinds {
    kind
    workload {
      ...Workload
    }
  }
`

interface Kind {
  kind: ModulesYamlKinds
  className?: string
}

export const KindItem: React.FC<Kind> = ({ kind, className = "" }) => (
  <li class={className}>
    <span>
      {kind?.subtitle ? `${kind?.subtitle} – ` : " "}
      {kind.kind}
    </span>
    <WorkloadItem workload={kind.workload} />
  </li>
)

interface KindList {
  kinds: ModulesYamlKinds[]
  className?: string
}

export const KindList: React.FC<KindList> = ({ kinds, className = "" }) => (
  <ul class="inline">
    {kinds.map((kind, index) => (
      <KindItem
        kind={kind}
        key={index}
        className={`inline comma-between or-before-last ${className}`}
      />
    ))}
  </ul>
)

interface CourseKind extends Course {
  children?: JSX.Element | JSX.Element[]
  className?: string
}

export const CourseKind: React.FC<CourseKind> = ({
  course,
  children,
  className = "inline",
}) => {
  return (
    <div class="inline">
      <KindItem kind={course?.kind} className={className} />
      <div class="border-l-2 pl-4">
        {children}
      </div>
    </div>
  )
}
